/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { ConfigParam } from '../models';
// @ts-ignore
import { Message } from '../models';
/**
 * ClientconfigService - axios parameter creator
 * @export
 */
export const ClientconfigServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert die Client Konfigurationen
         * @summary Client Konfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientConfig: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/config-param/clientconfig`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ändert eine Client Konfigurationen
         * @summary Client Konfiguration
         * @param {Array<ConfigParam>} [configParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setClientConfig: async (configParam?: Array<ConfigParam>, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/config-param/coco`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(configParam, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClientconfigService - functional programming interface
 * @export
 */
export const ClientconfigServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClientconfigServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert die Client Konfigurationen
         * @summary Client Konfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientConfig(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConfigParam>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientConfig(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * ändert eine Client Konfigurationen
         * @summary Client Konfiguration
         * @param {Array<ConfigParam>} [configParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setClientConfig(configParam?: Array<ConfigParam>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ConfigParam>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setClientConfig(configParam, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClientconfigService - factory interface
 * @export
 */
export const ClientconfigServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClientconfigServiceFp(configuration)
    return {
        /**
         * Liefert die Client Konfigurationen
         * @summary Client Konfiguration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientConfig(options?: any): AxiosPromise<Array<ConfigParam>> {
            return localVarFp.getClientConfig(options).then((request) => request(axios, basePath));
        },
        /**
         * ändert eine Client Konfigurationen
         * @summary Client Konfiguration
         * @param {Array<ConfigParam>} [configParam] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setClientConfig(configParam?: Array<ConfigParam>, options?: any): AxiosPromise<Array<ConfigParam>> {
            return localVarFp.setClientConfig(configParam, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClientconfigService - interface
 * @export
 * @interface ClientconfigService
 */
export interface ClientconfigServiceInterface {
    /**
     * Liefert die Client Konfigurationen
     * @summary Client Konfiguration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientconfigServiceInterface
     */
    getClientConfig(options?: any): AxiosPromise<Array<ConfigParam>>;

    /**
     * ändert eine Client Konfigurationen
     * @summary Client Konfiguration
     * @param {Array<ConfigParam>} [configParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientconfigServiceInterface
     */
    setClientConfig(configParam?: Array<ConfigParam>, options?: any): AxiosPromise<Array<ConfigParam>>;

}

/**
 * ClientconfigService - object-oriented interface
 * @export
 * @class ClientconfigService
 * @extends {BaseAPI}
 */
export class ClientconfigService extends BaseAPI implements ClientconfigServiceInterface {
    /**
     * Liefert die Client Konfigurationen
     * @summary Client Konfiguration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientconfigService
     */
    public getClientConfig(options?: any) {
        return ClientconfigServiceFp(this.configuration).getClientConfig(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ändert eine Client Konfigurationen
     * @summary Client Konfiguration
     * @param {Array<ConfigParam>} [configParam] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClientconfigService
     */
    public setClientConfig(configParam?: Array<ConfigParam>, options?: any) {
        return ClientconfigServiceFp(this.configuration).setClientConfig(configParam, options).then((request) => request(this.axios, this.basePath));
    }
}
